(() => {
  const controllerKey = '__spacetekProductReviewModalController';

  if (window[controllerKey]) {
    return;
  }

  const sourceRootSelector = '#judgeme_product_reviews';
  const sourceSelector = [
    '#judgeme_product_reviews .jm-media-grid__item',
    '#judgeme_product_reviews .jm-media-thumbnail-list__thumbnail'
  ].join(', ');
  const modalSelector = '.jdgm-modal.jdgm-widget-revamp';
  const modalMarkerClass = 'spacetek-product-review-modal';

  let pendingSource = null;
  let pendingTimer = 0;
  let markedModal = null;
  let markedSourceRoot = null;
  let observer = null;
  let reconcileFrame = 0;

  window[controllerKey] = true;

  const getProductPopupShell = (modal) => modal.querySelector(
    ':scope > .jdgm-modal__content[aria-label="Lightbox"], :scope > .jdgm-modal__content[aria-label="Review Media Gallery"]'
  );

  const isVisible = (element) => {
    if (!element || !element.isConnected) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const hasValidSource = (source) => {
    const sourceRoot = source && source.closest(sourceRootSelector);
    return Boolean(source && source.isConnected && sourceRoot && sourceRoot.isConnected && sourceRoot.contains(source));
  };

  const stopObservingIfIdle = () => {
    if (!pendingSource && !markedModal && observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const clearPending = () => {
    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      pendingTimer = 0;
    }

    pendingSource = null;
    stopObservingIfIdle();
  };

  const cleanupMarkedModal = () => {
    if (!markedModal) {
      return;
    }

    markedModal.classList.remove(modalMarkerClass);
    markedModal = null;
    markedSourceRoot = null;
    stopObservingIfIdle();
  };

  const startObserving = () => {
    if (observer || !document.body) {
      return;
    }

    observer = new MutationObserver(scheduleReconcile);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'style']
    });
  };

  const markModal = (modal, source) => {
    if (markedModal && markedModal !== modal) {
      cleanupMarkedModal();
    }

    modal.classList.add(modalMarkerClass);
    markedModal = modal;
    markedSourceRoot = source.closest(sourceRootSelector);
  };

  const findVisibleProductPopup = () => Array.from(document.querySelectorAll(modalSelector)).find(
    (modal) => isVisible(modal) && Boolean(getProductPopupShell(modal))
  );

  const reconcile = () => {
    reconcileFrame = 0;

    if (
      markedModal && (
        !isVisible(markedModal) ||
        !getProductPopupShell(markedModal) ||
        !markedSourceRoot ||
        !markedSourceRoot.isConnected
      )
    ) {
      cleanupMarkedModal();
    }

    if (pendingSource) {
      if (!hasValidSource(pendingSource)) {
        clearPending();
        return;
      }

      const modal = findVisibleProductPopup();
      if (modal) {
        markModal(modal, pendingSource);
        clearPending();
      }
    }

    stopObservingIfIdle();
  };

  function scheduleReconcile() {
    if (reconcileFrame) {
      return;
    }

    reconcileFrame = window.requestAnimationFrame(reconcile);
  }

  const setPendingSource = (source) => {
    clearPending();
    pendingSource = source;
    startObserving();
    scheduleReconcile();
    pendingTimer = window.setTimeout(clearPending, 2000);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const source = event.target.closest(sourceSelector);
    if (source) {
      setPendingSource(source);
      return;
    }

    if (markedModal && event.target.closest('.jm-indicator__close, .jdgm-modal__overlay')) {
      window.requestAnimationFrame(scheduleReconcile);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && markedModal) {
      window.requestAnimationFrame(scheduleReconcile);
    }
  }, true);

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (!(section instanceof Element)) {
      return;
    }

    if (pendingSource && section.contains(pendingSource)) {
      clearPending();
    }

    if (markedSourceRoot && section.contains(markedSourceRoot)) {
      cleanupMarkedModal();
    }
  });
})();
